module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/layouts/public/public.component.html
// module id = ../../../../../src-admin/app/layouts/public/public.component.html
// module chunks = main